import axios, { AxiosError, AxiosResponse } from "axios";
import { Dashboard } from "../Typings/Dashboard";
import { useQuery } from "@tanstack/react-query";


export function useGetDashboardQuery(clientId?: string) {
  return useQuery<Dashboard, unknown, Dashboard>(
    ["dashboard", clientId],
    async () => {
      const response: AxiosResponse<Dashboard> = await managementApiGetRequest(
        `api/Dashboard/${encodeURIComponent(clientId ?? "")}`
      );

      return response.data;
    },
    {
      enabled: !!clientId,
    }
  );
}

const managementApiGetRequest: (path: string) => Promise<any> = async function (
  path: string
) {
  let rootUrl = import.meta.env.VITE_ACTIVATE_BACKEND_API;

  const response = axios
    .get(`${rootUrl}/${path}`)
    .catch((error: AxiosError) => {
      throw new Error(error.message);
    })
    .then((res) => res);

  return await response;
};
